import React from 'react'
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'
import { Link } from 'react-router-dom';

const ProductList = props => {
    if (!props.products) {
        return (
            <div className='broad'>Loading...</div>
        );
    }

    if (props.products.length === 0) {
        return (
            <div className='empty'>
                No products...
            </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>Key</th>
                        <th>Name</th>
                        <th>Price</th>
                        <th>Currency</th>
                        <th>Category</th>
                        <th>userkey</th>
                        <th>Created</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.products.map(item => {
                            return (
                                <tr key={item.key}>
                                    <td className="keyfield"><Link to={`/product/${item.key}/detail`}>{item.key}</Link></td>
                                    <td>{item.name}</td>
                                    <td>{item.price}</td>
                                    <td>{item.currency}</td>
                                    <td className="keyfield"><Link to={`/category/${item.category_key}/detail`}>{item.category_name}</Link></td>
                                    <td className="keyfield"><Link to={`/users/${item.userkey}`}>{item.userkey}</Link></td>
                                    <td>{dateHelper.Formatter.toLocalString(item.created)}</td>
                                    <td className="keyfield"><Link to={`/product/${item.key}/edit`}>Edit</Link></td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/widgets/ProductList.js